<template>
  <path
    d="M19 5.00024C19 3.90024 18.1 3.00024 17 3.00024H10.83C10.3 3.00024 9.78999 3.21024 9.40999 3.59024L7.94999 5.06024L19 16.1102V5.00024ZM3.08999 4.44024C2.69999 4.83024 2.69999 5.46024 3.08999 5.85024L4.99999 7.78024V19.0002C4.99999 20.1102 5.89999 21.0002 6.99999 21.0002H18.23L19.14 21.9102C19.53 22.3002 20.16 22.3002 20.55 21.9102C20.94 21.5202 20.94 20.8902 20.55 20.5002L4.49999 4.44024C4.10999 4.05024 3.47999 4.05024 3.08999 4.44024Z"
  />
</template>
